export default {
  methods: {
    captureApmError (error, details = {}) {
      console.error(error, details)
      window.APM_CONFIG && this.$apm.captureError(error) // Note: After Vue 3 migration, add "details" as second argument"
    }
  }
}
